<button
  class="btn"
  [type]="type()"
  [disabled]="isDisabled()"
  [attr.aria-label]="ariaLabel()"
  [attr.aria-busy]="loading() ? 'true' : null"
  [class]="'btn--' + variant() + ' btn--' + size()"
  [class.btn--icon-only]="iconOnly()"
  [class.btn--full]="fullWidth()"
  [class.btn--wrap]="wrap()"
  [class.btn--flat]="flat()"
  [class.btn--loading]="loading()"
  (click)="onClick()"
>
  @if (loading()) {
    <span class="btn__spinner" aria-hidden="true"></span>
  }
  <span class="btn__content">
    <ng-content></ng-content>
  </span>
</button>
